<template>
    <multiselect
            :options="projectContactsByProjectId(projectId)"
            v-model="subscribedContacts"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :multiple="true"
            placeholder="Subscribed Contacts to notify"
            label="full_name"
            track-by="id"
            @input="$emit('submitting', true)"
    ></multiselect>
</template>

<script>
    import SubscribedContacts from '../mixins/SubscribedContacts'

    export default {
        mixins: [SubscribedContacts],

        watch: {
            subscribedContacts: {
                deep: true,
                handler() {
                    if (!this.dataLoaded) return

                    // defer the subscribers update
                    if (this.syncTimeout) {
                        clearTimeout(this.syncTimeout)
                    }

                    this.syncTimeout = setTimeout(() => {
                        this.handleUpdate()
                    }, 3000)
                }
            }
        },

        mounted() {
            if (this.referenceType === 'project') {
                this.projectId = this.$route.params.slug
            } else {
                this.projectId = this.taskById(this.$route.params.slug).project_id
            }

            this.fetchContacts({project_id: this.projectId}).then(() => {
                let ids = this.currentSubscribedContactsIds

                this.subscribedContacts = _.filter(this.contacts, contact =>
                    ids.includes(contact.id)
                )

                this.$nextTick(() => {
                    this.dataLoaded = true
                })
            })
        },

        beforeDestroy() {
            if (this.syncTimeout) {
                clearTimeout(this.syncTimeout)
            }

            this.handleUpdate()
        }
    }
</script>
